import { render } from "./allOffers.vue?vue&type=template&id=7fc51d30&ts=true"
import script from "./allOffers.vue?vue&type=script&lang=ts"
export * from "./allOffers.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__